import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import { RecommendationBaseView } from '../../sharedComponents/RecommendationBaseView';
import { View } from 'foundations-components/transitional/components/View';
import { LockedIcon } from 'foundations-assets/icons/components/LockedIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const UpgradeForFormAutomationView = ({
  auditResult
}) => {
  const {
    openUpgradeModal
  } = useUpgradeModal('forms-simple-automation-xray');
  return /*#__PURE__*/_jsx(RecommendationBaseView, {
    testId: "add-form-follow-up-email",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.title.UPGRADE_FOR_FORM_AUTOMATION"
    }),
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.description.UPGRADE_FOR_FORM_AUTOMATION"
    }),
    status: auditResult.status,
    children: /*#__PURE__*/_jsx(View, {
      marginInlineStart: "600",
      marginBlockEnd: "200",
      as: "div",
      children: /*#__PURE__*/_jsxs(Link, {
        onClick: openUpgradeModal,
        children: [/*#__PURE__*/_jsx(LockedIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "xray-recommendation-lib.seo.recommendations.linkText.UPGRADE_FOR_FORM_AUTOMATION"
        })]
      })
    })
  });
};